<template>
  <section id="about-me-section">
    <div class="flex flex-column flex-justify-center flex-align-center">
      <h1>A LITTLE ABOUT ME</h1>
      <div
        class="container flex flex-row flex-justify-center flex-align-center"
      >
        <div>
          <p class="text--align-left">
            I am passionate about creating effective, engaging websites and
            innovative software solutions that deliver exceptional user
            experiences to meet the needs of businesses and individuals.
          </p>

          <p class="text--align-left">
            I have a proven track record of delivering high-quality software
            products that meet and exceed client expectations. My approach to
            software development is collaborative and customer-focused, and I
            strive to understand each client's unique needs and goals to create
            a tailored solution that is both effective and efficient.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      observer: null,
      elementToWatch: null,
    };
  },
  methods: {
    avatarEffect() {
      let options = {
        rootMargin: "0px",
        threshold: 1.0,
      };
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry && entry.isIntersecting) {
          var box = document.getElementById("my-avatar-id");
          box.classList.add("active");
          this.observer.unobserve(this.elementToWatch);
        }
      }, options);
      this.elementToWatch = document.querySelector("#my-avatar-id");
      this.observer.observe(this.elementToWatch);
    },
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>
<style lang="scss" scoped>
.my-avatar-wrapper {
  height: 300px;
  width: 300px;
  position: relative;
  margin-left: 100px;
}
.my-avatar {
  /* Background */
  background-image: url("../../assets/images/myAvatar.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  /* Position */
  position: relative;
  width: 300px;
  height: 300px;

  /* Box settings */
  overflow: hidden;
  display: inline-block;
}

.my-avatar::before {
  content: "";
  display: block;

  /* Scale */
  width: 10%;
  padding-bottom: 10%;

  /* Position */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  /* Border */
  border: solid 300px #161616;
  border-radius: 50%;

  transition: width 0.2s cubic-bezier(0, 0, 0.3, 1),
    padding-bottom 0.2s cubic-bezier(0, 0, 0.3, 1);
  -webkit-transition: width 0.2s cubic-bezier(0, 0, 0.3, 1),
    padding-bottom 0.2s cubic-bezier(0, 0, 0.3, 1);
  -moz-transition: width 0.2s cubic-bezier(0, 0, 0.3, 1),
    padding-bottom 0.2s cubic-bezier(0, 0, 0.3, 1);
  -o-transition: width 0.2s cubic-bezier(0, 0, 0.3, 1),
    padding-bottom 0.2s cubic-bezier(0, 0, 0.3, 1);
}
.my-avatar.active::before {
  animation: animateThis 2s;
  width: 100%;
  padding-bottom: 100%;
}

@keyframes animateThis {
  0% {
    width: 10%;
    padding-bottom: 10%;
  }
  20% {
    width: 60%;
    padding-bottom: 60%;
  }
  50% {
    width: 40%;
    padding-bottom: 40%;
  }
  100% {
    width: 100%;
    padding-bottom: 100%;
  }
}
</style>
